








import Vue from 'vue';
import { Loading } from '@descomplica/vue-components';

export default Vue.extend({
  components: { Loading },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
});
